//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "studycenter",
  data() {
    return {
      weekArr:[],
      today:0,
      learningData:{}
    }
  },
  computed: {},
  mounted() {
    var date = new Date();
    var nowweek = date.getDay();
    var sunday = date.getTime() - nowweek * 24 * 60 * 60 * 1000;
    var dataArr=[];
    for (let i =0;i<7;i++){
      dataArr.push(new Date(sunday+i*24*60*60*1000).getDate());
    }
    console.log(dataArr);
    this.weekArr=dataArr;
    this.today=date.getDate();
  },
  methods: {
    days: function (index) {
      switch (index) {
        case 1:
          return '日';
        case 2:
          return '一';
        case 3:
          return '二';
        case 4:
          return '三';
        case 5:
          return '四';
        case 6:
          return '五';
        case 7:
          return '六';
      }
    },
    goredrocket(id){
        location.href='/dist/#/HomeList?user_key='+this.$store.state.user_key+'&id='+id;
    },
    goach(id){
      location.href='/dist/#/myAchievementh5?user_key='+this.$store.state.user_key+'&id='+id;
    }
  },
  created() {
    this.axios.post('/xcx/User/learningCenter').then(res=>{
      this.learningData=res.data.data;
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/studycenter/studycenter.vue